<template>
	<v-card>
	  <v-toolbar flat dense>
		<v-toolbar-title class="subheading text-xs-center">Version History</v-toolbar-title>
		<v-spacer></v-spacer>
	  </v-toolbar>
  
	  <v-card-text class="text-xs-left" v-if="certification">
		<v-label>Showing history for {{ certification.name }}</v-label>
  
		<div class="d-flex justify-center" style="height: 100px;" v-if="isLoading">
		  <v-progress-circular indeterminate color="primary"></v-progress-circular>
		</div>
  
		<v-list two-line v-else>
		  <v-list-tile v-for="(cert, index) in versionsDesc" :key="cert.id">
			<v-list-tile-content>
			  <div class="d-flex align-center">
				Version {{ cert.versionNumber }}
				<v-tooltip bottom v-if="cert.deleted">
				  <template slot="activator" slot-scope="props">
					<v-chip small color="error" class="ml-2" dark v-bind="props.attrs" v-on="props.on">Deleted</v-chip>
				  </template>
				  <span>Deleted by {{ cert.deletedByName }}</span>
				</v-tooltip>
				<v-chip small v-else-if="index === 0" color="info" dark class="ml-2">Latest</v-chip>
			  </div>
  
			  <v-list-tile-sub-title>
				<v-tooltip bottom>
				  <template slot="activator" slot-scope="props">
					<span v-bind="props.attrs" v-on="props.on">Created {{ moment(cert.createdDateUtc).format('lll') }}</span>
				  </template>
				  <span>Created by {{ cert.addedByUserName }}</span>
				</v-tooltip>
  
				<span v-if="cert.expiryDate"> • {{ dateHasPassed(cert.expiryDate) ? 'Expired ' : 'Expiring ' }}{{ moment(cert.expiryDate).format('ll') }}</span>
			  </v-list-tile-sub-title>
			</v-list-tile-content>
		  </v-list-tile>
		</v-list>
	  </v-card-text>
	</v-card>
  </template>
  
  <script>
  import { mapActions } from 'vuex';
  import moment from 'moment';
  
  export default {
	name: 'CertificationVersionHistory',
	props: {
	  certification: {
		type: Object,
		required: false
	  }
	},
	data() {
	  return {
		versions: [],
		isLoading: false,
	  };
	},
	computed: {
	  versionsDesc() {
		return [...this.versions].sort((a, b) => b.versionNumber - a.versionNumber);
	  }
	},
	watch: {
	  certification: {
		immediate: true,
		async handler(val) {
		  this.versions = [];
		  if (!val) return;
  
		  this.isLoading = true;
		  const result = await this.getAllVersion({
			employeeId: val.employeeId,
			certificationTypeId: val.certificationTypeId
		  });
  
		  if (result.isSuccess) {
			this.versions = result.data;
		  }
  
		  this.isLoading = false;
		}
	  }
	},
	methods: {
	  moment,
	  ...mapActions({
		getAllVersion: 'certifications/getAllVersionsByEmployee'
	  }),
	  dateHasPassed(utcString) {
		return moment(utcString).isBefore(moment());
	  }
	}
  };
  </script>
  
  <style scoped>
  </style>
  